import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import { useContext, useEffect } from 'react';
import { AuthContext } from './context/AuthContext';
import CompleteProfile from './pages/CompleteProfile';
import Payment from './pages/Payment';
import SelectIndustry from './pages/SelectIndustry.jsx';
import Admin from './pages/Admin';
import AdminUsers from './pages/AdminUsers';
import AdminBilling from './pages/AdminBilling'; 
import AdminCategories from './pages/AdminCategories';
import AdminIndustries from './pages/AdminIndustries.jsx';
import AdminApps from './pages/AdminApps';
import { Toaster } from 'react-hot-toast';
import AdminPlans from './pages/AdminPlans'; 
import DynamicAppRenderer from './pages/DynamicAppRenderer.jsx';
import AIContentCreatorApp from './pages/apps/AIContentCreatorApp';
import MyCreationsDashboard from './pages/apps/MyCreationsDashboard';
import ProfilePage from './pages/account/ProfilePage';
import SubscriptionPage from './pages/account/SubscriptionPage';
import AdminCountries from './pages/AdminCountries.jsx';
import AdminCoupons from './pages/AdminCoupons.jsx';
import BillingHistory from './pages/account/BillingHistory.jsx';
import ManageTeam from './pages/account/ManageTeam.jsx';
import CheckEmail from './pages/CheckEmail.js';
import ForgotPassword from './pages/ForgotPassword.js';
import ResetPassword from './pages/ResetPassword.js';
import ManagePaymentMethod from './pages/account/PaymentMethodsPage.jsx';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EmailMentor from './pages/apps/EmailMentor.jsx';
import StudySnap from './pages/apps/StudySnap.jsx';
import BrandForge from './pages/apps/BrandForge.jsx';
import DocuCraft from './pages/apps/DocuCraft.jsx';
import FlowBuilder from './pages/apps/FlowBuilder.jsx';
import MeetGenie from './pages/apps/MeetGenie.jsx';
import MeetMate from './pages/apps/MeetMate.jsx';
import PitchCraft from './pages/apps/PitchCraft.jsx';
import SkillSage from './pages/apps/SkillSage.jsx';
import TrendPulse from './pages/apps/TrendPulse.jsx';
import VisionGaurd from './pages/apps/VisionGaurd.jsx';
import WikiForge from './pages/apps/WikiForge.jsx';
import LeadCollector from './pages/apps/LeadCollector.jsx';
import CapturedLeads from './pages/apps/CapturedLeads.jsx';
import ScriptCraft from './pages/apps/ScriptCraft.jsx';
import AdGenieSalons from './pages/apps/AdGenieSalons.jsx';
import BrandProfile from './pages/BrandProfile.jsx';
import ReplyBotOnboarding from './pages/apps/Replybot/ReplyBotOnboarding';
import ReplyBotInbox from './pages/apps/Replybot/ReplyBotInbox';
import ReplyBotSettings from './pages/apps/Replybot/ReplyBotSettings';
import ReplyBotTemplates from './pages/apps/Replybot/ReplyBotTemplates';
import ReplyBotOAuthCallback from './pages/apps/Replybot/ReplyBotOAuthCallback.jsx';
import WhatsAppConnect from './pages/apps/Replybot/WhatsAppConnect.jsx';
import ReplyBotWhatsAppCallback from './pages/apps/Replybot/ReplyBotWhatsAppCallback.jsx';





function App() {
  const { user } = useContext(AuthContext);
  useEffect(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: process.env.REACT_APP_META_APP_ID,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v18.0',
      });
    };
  }, []);
  
  return (
    <>
    <Toaster position="top-right" reverseOrder={false} />
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to={user ? "/dashboard" : "/login"} />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/dashboard"
          element={user ? <Dashboard /> : <Navigate to="/login" />}
        />
        <Route path="/complete-profile" element={<CompleteProfile />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/selectindustry" element={<SelectIndustry />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/billing" element={<AdminBilling />} />
        <Route path="/admin/categories" element={<AdminCategories />} />
        <Route path="/admin/industries" element={<AdminIndustries />} />
        <Route path="/admin/apps" element={<AdminApps />} />
        <Route path="/admin/plans" element={<AdminPlans />} /> 
        <Route path="/app/:routeKey" element={<DynamicAppRenderer />} />
        <Route path="/apps/content-creator" element={<AIContentCreatorApp />} />
        <Route path="/app/content-creator/my-creations" element={<MyCreationsDashboard />} />
        <Route path="/account/profile" element={<ProfilePage />} />
        <Route path="/account/subscription" element={<SubscriptionPage />} />
        <Route path="/account/manage-team" element={<ManageTeam />} />
        <Route path="/admin/countries" element={<AdminCountries />} />
        <Route path="/admin/coupons" element={<AdminCoupons />} />
        <Route path="/account/billing" element={<BillingHistory />} />
        <Route path="/account/paymentmethods" element={<ManagePaymentMethod />} />
        <Route path='/check-email' element={<CheckEmail />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/reset-password' element={<ResetPassword />} />
        <Route path="/apps/email-mentor" element={<EmailMentor />} />
        <Route path="/apps/study-snap" element={<StudySnap />} />
        <Route path="/apps/brand-forge" element={<BrandForge />} />
        <Route path="/apps/docu-craft" element={<DocuCraft />} />
        <Route path="/apps/flow-builder" element={<FlowBuilder />} />
        <Route path="/apps/meet-genie" element={<MeetGenie />} />
        <Route path="/apps/meet-mate" element={<MeetMate />} />
        <Route path="/apps/pitch-craft" element={<PitchCraft />} />
        <Route path="/apps/skill-sage" element={<SkillSage />} />
        <Route path="/apps/trend-pulse" element={<TrendPulse />} />
        <Route path="/apps/vision-gaurd" element={<VisionGaurd />} />
        <Route path="/apps/wiki-forge" element={<WikiForge />} />
        <Route path='/apps/lead-collector' element={<LeadCollector />} />
        <Route path='/app/lead-collector/leads' element={<CapturedLeads />} />
        <Route path='/apps/script-craft' element={<ScriptCraft />}/>
        <Route path='/apps/ad-genie-salon' element={<AdGenieSalons />} />
        <Route path='/brand-profile' element={<BrandProfile />} />
        <Route path="/apps/replybot/onboarding" element={<ReplyBotOnboarding />} />
<Route path="/app/replybot/inbox" element={<ReplyBotInbox />} />
<Route path="/app/replybot/settings" element={<ReplyBotSettings />} />
<Route path="/app/replybot/templates" element={<ReplyBotTemplates />} />
<Route path="/apps/replybot/connect/callback" element={<ReplyBotOAuthCallback />} />
<Route path="/apps/replybot/whatsapp-connect" element={<WhatsAppConnect />} />
<Route path="/apps/replybot/whatsapp/callback" element={<ReplyBotWhatsAppCallback />} />

        
      </Routes>
      
    </Router>

<ToastContainer position="top-center" autoClose={4000} />
    </>
  );
}

export default App;
